document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-testimonials-prev], [data-testimonials-next]');
  if (!button) return;

  const section = button.closest('atelier-testimonials');
  const viewport = section?.querySelector('[data-testimonials-viewport]');
  const card = section?.querySelector('.atelier-testimonial');
  const track = section?.querySelector('.atelier-testimonials__track');
  if (!viewport || !card || !track) return;

  const direction = button.hasAttribute('data-testimonials-next') ? 1 : -1;
  const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;

  viewport.scrollBy({
    left: direction * (card.getBoundingClientRect().width + gap),
    behavior: 'smooth',
  });
});
